import React, { Component } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
// import "./main.scss"; // webpack must be configured to do this

export default class LearnerCalendar extends Component {
  state = {
    events: [
      {
        title: 'All Day Event',
        start: '2019-07-01'
      },
      {
        title: 'Click for Google',
        url: 'http://google.com/',
        start: '2020-06-28'
      }
    ]
  }
  viewEvent = (e) => {
    var eventObj = e.event;

    console.log("calender onclick  :: " , eventObj)
    if (eventObj.url) {
      // alert(
      //   'Clicked ' + eventObj.title + '.\n' +
      //   'Will open ' + eventObj.url + ' in a new tab'
      // );
      window.location.href = `#${eventObj.url}`

      e.jsEvent.preventDefault(); // prevents browser from following link in current tab.
    } else {
      // window.location.href = `#/${eventObj.link}`
      alert('Clicked ' + eventObj.title);
    }
  }
  componentDidMount() {
    this.getCalendarData();
  }
  getCalendarData = () => {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("userId", localStorage.getItem('lms_uid'));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/calender", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        var data = []
        for (var i = 0; i < result.data.length; i++) {
          var obj = {}
          obj.title = result.data[i].name
          obj.url = `/learner/view-topic/${result.data[i].course_id}&${result.data[i].id}`
          obj.start = result.data[i].start
          obj.end = result.data[i].end

          data.push(obj);
        }
        this.setState({ events: data, loading: false })
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container create-course border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/learner/course-list">Home</Link> /
                    <b> Calendar</b>
                  </h5>
                </div>
                {/* <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <Link
                    to="/calendar/add-event"
                    className="btn btn-dark float-right"
                  >
                    Add Event
                  </Link>
                </div> */}
              </div>
            </div>

            <div className="users-container p-2">
              <FullCalendar
                defaultView="dayGridMonth"
                plugins={[dayGridPlugin]}
                events={this.state.events}
                eventClick={this.viewEvent}
              />
            </div>
          </div>
        </div>
      </div >
    );
  }
}
